import axios from "axios";
import {appConfig} from "../../config/defaultConfig";
import {getAuthToken} from "../../config/localStorage";

const IROH_SERVICES = appConfig.APP.IROH_SERVICES;

export const publish = (payload) => {
  if (getAuthToken()) {
    payload.metric = 0;
    return axios.post(IROH_SERVICES.ROUTES.TELEMETRY, [payload]);
  }
};

// master telemetry key for xdr apps
const APP_KEY = "xdr-ui";

// Pages in the Incidents and Investigate XDR apps
const PAGE = {
  INCIDENTS: `${APP_KEY}.incidents`,
  INCIDENT_DETAIL: `${APP_KEY}.incident-detail`,
  INVESTIGATE: `${APP_KEY}.investigate`,
  SAVED_INVESTIGATIONS: `${APP_KEY}.saved-investigations`
};

// types of data used
const DATA = {
  ASSETS: "assets",
  OBSERVABLES: "observables",
  INDICATORS: "indicators",
  SHORT_DESCRIPTION: "short-description",
  LONG_DESCRIPTION: "long-description",
  STATUS: "status"
};

// common page components
const COMPONENT = {
  BREADCRUMB: "breadcrumb",
  BUTTON: "button",
  CARD: "card",
  DRAWER: "drawer",
  LINK: "link",
  MENU: "menu",
  TAB: "tab",
  TABLE: "table",
  WIDGET: "widget"
};

// drawer sections
const DRAWER = {
  ASSETS: `${COMPONENT.DRAWER}.${DATA.ASSETS}`,
  BREADCRUMB: `${COMPONENT.DRAWER}.${COMPONENT.BREADCRUMB}`,
  OBSERVABLES: `${COMPONENT.DRAWER}.${DATA.OBSERVABLES}`,
  INDICATORS: `${COMPONENT.DRAWER}.${DATA.INDICATORS}`,
  LONG_DESCRIPTION: `${COMPONENT.DRAWER}.${DATA.LONG_DESCRIPTION}`,
  SHORT_DESCRIPTION: `${COMPONENT.DRAWER}.${DATA.SHORT_DESCRIPTION}`
};

// types of dropdown menus
const MENU = {
  ASSIGNEES: `${COMPONENT.MENU}.assignees`,
  BULK_ACTION: `${COMPONENT.MENU}.bulk-action`,
  DATE_RANGE: `${COMPONENT.MENU}.date-range`,
  FILTER: `${COMPONENT.MENU}.filter`,
  STATUS: `${COMPONENT.MENU}.status`
};

// types of buttons
const BUTTON = {
  ADD_NOTE: `${COMPONENT.BUTTON}.add-note`,
  ADD_NOTE_RESPONSE: `${COMPONENT.BUTTON}.response-add-note`,
  AUDIT_LOG: `${COMPONENT.BUTTON}.audit-log`,
  CLOSE_INCIDENT: `${COMPONENT.BUTTON}.response-close-incident`,
  INCIDENT_TITLE_TEXT: `${COMPONENT.BUTTON}.incident-title-text`, // text as <Button>
  INVESTIGATE_INCIDENT: `${COMPONENT.BUTTON}.investigate-incident`,
  NOTES: `${COMPONENT.BUTTON}.notes`,
  THEME: `${COMPONENT.BUTTON}.theme`,
  VIEW_INCIDENT_DETAILS: `${COMPONENT.BUTTON}.view-incident-details`
};

// types of tabs
const TAB = {
  OVERVIEW: `${COMPONENT.TAB}.overview`,
  DETECTION: `${COMPONENT.TAB}.detection`,
  RESPONSE: `${COMPONENT.TAB}.response`,
  WORKLOG: `${COMPONENT.TAB}.worklog`
};

// types of links
const LINK = {
  VIEW_ASSETS: `${COMPONENT.LINK}.view-${DATA.ASSETS}`,
  VIEW_OBSERVABLES: `${COMPONENT.LINK}.view-${DATA.OBSERVABLES}`,
  VIEW_INDICATORS: `${COMPONENT.LINK}.view-${DATA.INDICATORS}`
};

// types of cards
const CARD = {
  ENTITY: `${COMPONENT.CARD}.entity`
};

// types of widgets
const WIDGET = {
  MITRE: `${COMPONENT.WIDGET}.mitre`
};

export const FEATURE = {
  INCIDENTS: {
    BUTTON_THEME: `${PAGE.INCIDENTS}.${BUTTON.THEME}`,
    BUTTON_TITLE_TEXT: `${PAGE.INCIDENTS}.${BUTTON.INCIDENT_TITLE_TEXT}`,
    BUTTON_VIEW_INCIDENT_DETAILS: `${PAGE.INCIDENTS}.${BUTTON.VIEW_INCIDENT_DETAILS}`,
    DRAWER: `${PAGE.INCIDENTS}.${COMPONENT.DRAWER}`,
    DRAWER_ASSETS: `${PAGE.INCIDENTS}.${DRAWER.ASSETS}`,
    DRAWER_LONG_DESCRIPTION: `${PAGE.INCIDENTS}.${DRAWER.LONG_DESCRIPTION}`,
    DRAWER_SHORT_DESCRIPTION: `${PAGE.INCIDENTS}.${DRAWER.SHORT_DESCRIPTION}`,
    MENU_ASSIGNEES: `${PAGE.INCIDENTS}.${MENU.ASSIGNEES}`,
    MENU_DATE_RANGE: `${PAGE.INCIDENTS}.${MENU.DATE_RANGE}`,
    MENU_FILTER: `${PAGE.INCIDENTS}.${MENU.FILTER}`,
    MENU_STATUS: `${PAGE.INCIDENTS}.${MENU.STATUS}`,
    MENU_STATUS_BULK_ACTION: `${PAGE.INCIDENTS}.${MENU.BULK_ACTION}.${DATA.STATUS}`
  },
  INCIDENT_DETAIL: {
    BUTTON_INVESTIGATE_INCIDENT: `${PAGE.INCIDENT_DETAIL}.${BUTTON.INVESTIGATE_INCIDENT}`,
    ENTITY_CARD: `${PAGE.INCIDENT_DETAIL}.${CARD.ENTITY}`,
    DRAWER: `${PAGE.INCIDENT_DETAIL}.${COMPONENT.DRAWER}`,
    DRAWER_ASSETS: `${PAGE.INCIDENT_DETAIL}.${DRAWER.ASSETS}`,
    DRAWER_OBSERVABLES: `${PAGE.INCIDENT_DETAIL}.${DRAWER.OBSERVABLES}`,
    LINK_VIEW_ASSETS: `${PAGE.INCIDENT_DETAIL}.${LINK.VIEW_ASSETS}`,
    LINK_VIEW_OBSERVABLES: `${PAGE.INCIDENT_DETAIL}.${LINK.VIEW_OBSERVABLES}`,
    LINK_VIEW_INDICATORS: `${PAGE.INCIDENT_DETAIL}.${LINK.VIEW_INDICATORS}`,
    LONG_DESCRIPTION: `${PAGE.INCIDENT_DETAIL}.${DATA.LONG_DESCRIPTION}`,
    MENU_ASSIGNEES: `${PAGE.INCIDENT_DETAIL}.${MENU.ASSIGNEES}`,
    MENU_STATUS: `${PAGE.INCIDENT_DETAIL}.${MENU.STATUS}`,
    MITRE_WIDGET: `${PAGE.INCIDENT_DETAIL}.${WIDGET.MITRE}`,
    RESPONSE_ADD_NOTE: `${PAGE.INCIDENT_DETAIL}.${BUTTON.ADD_NOTE_RESPONSE}`,
    RESPONSE_CLOSE_INCIDENT: `${PAGE.INCIDENT_DETAIL}.${BUTTON.CLOSE_INCIDENT}`,
    SHORT_DESCRIPTION: `${PAGE.INCIDENT_DETAIL}.${DATA.SHORT_DESCRIPTION}`,
    TAB_OVERVIEW: `${PAGE.INCIDENT_DETAIL}.${TAB.OVERVIEW}`,
    TAB_DETECTION: `${PAGE.INCIDENT_DETAIL}.${TAB.DETECTION}`,
    TAB_RESPONSE: `${PAGE.INCIDENT_DETAIL}.${TAB.RESPONSE}`,
    TAB_WORKLOG: `${PAGE.INCIDENT_DETAIL}.${TAB.WORKLOG}`,
    WORKLOG_ADD_NOTE: `${PAGE.INCIDENT_DETAIL}.${BUTTON.ADD_NOTE}`,
    WORKLOG_BUTTON_NOTES: `${PAGE.INCIDENT_DETAIL}.${TAB.WORKLOG}.${BUTTON.NOTES}`,
    WORKLOG_BUTTON_AUDITLOG: `${PAGE.INCIDENT_DETAIL}.${TAB.WORKLOG}.${BUTTON.AUDIT_LOG}`
  },
  INVESTIGATE: {},
  SAVED_INVESTIGATIONS: {
    BREADCRUMB: `${PAGE.SAVED_INVESTIGATIONS}.${COMPONENT.BREADCRUMB}`
  }
};

export const ACTION = {
  ASSIGN: "assign",
  CANCEL: "cancel",
  CLICK: "click",
  CLOSE: "close",
  CREATE: "create",
  DELETE: "delete",
  EDIT: "edit",
  LINK: "link",
  OPEN: "open",
  SAVE: "save",
  SET: "set", // use for dropdown menus
  UNASSIGN: "unassign",
  UNLINK: "unlink",
  UPDATE: "update"
};
